<template>
  <el-card class="my-box-card" >
    <el-tabs v-model="activeName"  type="border-card">
      <el-tab-pane label="未读消息" name="first">
        <div class="infinite-list-wrapper" style="overflow:auto">
          <ul
            class="list"
            infinite-scroll-disabled="disabled">
            <li class="list-item">您的会员三天后过期</li>
            <li class="list-item">您的委托单已经开始检验</li>
            <li class="list-item">您有新的企标</li>
          </ul>
        </div>
      </el-tab-pane>
      <el-tab-pane label="已读消息" name="second">
        <div class="infinite-list-wrapper" style="overflow:auto">
          <ul
            class="list"
            infinite-scroll-disabled="disabled">
            <li class="list-item">您的会员三天后过期</li>
            <li class="list-item">您的委托单已经开始检验</li>
            <li class="list-item">您有新的企标</li>
          </ul>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import { list, edit } from '@/api/user/message'
export default {
  name: 'myMessage',
  data () {
    return {
      activeName: 'first',
      loading: false,
      pageParam: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      formParam: {}
    }
  },
  created () {
    this.handleSearch()
  },
  methods: {
    handleSearch () {
      this.formParam.page = {
        pageNum: this.pageParam.currentPage,
        pageSize: this.pageParam.pageSize
      }
      this.mockTableData()
    },
    mockTableData () {
      list(this.formParam).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.tableData = result.bizData
          this.pageParam.total = result.total
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    },
    editStatus () {
      edit(this.formParam).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.tableData = result.bizData
          this.pageParam.total = result.total
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    }
  }
}
</script>

<style scoped>

</style>
